module.exports = __webpack_public_path__ + "static/img/bg_coupon_two.5ee2978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_two.png
// module id = ijEY
// module chunks = 0